/*! Wi-navbars - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

// ── Navbar scroll + theme detection ─────────────────────────────────────────
(function () {
    'use strict';

    var navbar = document.getElementById('navbar-main');
    if (!navbar) return;

    var scrollThreshold = 80;
    var detectTimer = null;
    var wasColored = false;

    function getLuminance(r, g, b) {
        var a = [r, g, b].map(function (v) {
            v /= 255;
            return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
        });
        return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
    }

    function parseRgb(str) {
        var m = str && str.match(/[\d.]+/g);
        if (!m || m.length < 3) return null;
        var alpha = m.length >= 4 ? +m[3] : 1;
        if (alpha < 0.15) return null;
        return [+m[0], +m[1], +m[2]];
    }

    function hexToRgb(hex) {
        var r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        if (r) return [parseInt(r[1], 16), parseInt(r[2], 16), parseInt(r[3], 16)];
        var s = /^#?([a-f\d])([a-f\d])([a-f\d])$/i.exec(hex);
        if (s) return [parseInt(s[1]+s[1], 16), parseInt(s[2]+s[2], 16), parseInt(s[3]+s[3], 16)];
        return null;
    }

    function isDarkGradient(gradStr) {
        var rgbs = gradStr.match(/rgba?\([^)]+\)/g) || [];
        var hexs = gradStr.match(/#[0-9a-fA-F]{3,8}/g) || [];
        var total = 0, count = 0;
        rgbs.forEach(function(c) { var v = parseRgb(c); if (v) { total += getLuminance(v[0],v[1],v[2]); count++; } });
        hexs.forEach(function(c) { var v = hexToRgb(c); if (v) { total += getLuminance(v[0],v[1],v[2]); count++; } });
        return count === 0 ? false : (total / count) < 0.35;
    }

    function effectiveBgRgb(el) {
        var current = el;
        while (current && current !== document.documentElement) {
            var style = window.getComputedStyle(current);
            var bg = style.backgroundColor;
            if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
                var rgb = parseRgb(bg);
                if (rgb) return rgb;
            }
            current = current.parentElement;
        }
        return [250, 248, 245];
    }

    var darkClasses = ['carousel', 'hero', 'bg-primary', 'bg-secondary', 'bg-dark', 'bg-black'];

    function detectTheme() {
        var cx = Math.round(window.innerWidth / 2);
        var adminBar = document.querySelector('.navbar-admin');
        var cy = (adminBar ? adminBar.offsetHeight : 0) + navbar.offsetHeight;

        var el = document.elementFromPoint(cx, cy);

        if (!el) { setTheme('light'); return; }

        var walker = el;
        while (walker && walker !== document.documentElement) {
            var cls = (typeof walker.className === 'string') ? walker.className : '';
            for (var i = 0; i < darkClasses.length; i++) {
                if (cls.indexOf(darkClasses[i]) !== -1) {
                    setTheme('dark');
                    return;
                }
            }
            var wBgImg = window.getComputedStyle(walker).backgroundImage;
            if (wBgImg && wBgImg !== 'none') {
                if (wBgImg.indexOf('gradient') !== -1) {
                    if (isDarkGradient(wBgImg)) { setTheme('dark'); return; }
                } else {
                    setTheme('dark'); return;
                }
            }
            walker = walker.parentElement;
        }

        var rgb = effectiveBgRgb(el);
        var lum = getLuminance(rgb[0], rgb[1], rgb[2]);
        setTheme(lum < 0.35 ? 'dark' : 'light');
    }

    function setTheme(theme) {
        if (theme === 'dark') {
            navbar.classList.add('navbar-on-dark');
            navbar.classList.remove('navbar-on-light');
        } else {
            navbar.classList.add('navbar-on-light');
            navbar.classList.remove('navbar-on-dark');
        }
    }

    function onScroll() {
        var y = window.pageYOffset || document.documentElement.scrollTop;
        if (y > scrollThreshold) {
            if (detectTimer) { clearTimeout(detectTimer); detectTimer = null; }
            navbar.classList.add('navbar-color');
            setTheme('light');
            wasColored = true;
        } else {
            navbar.classList.remove('navbar-color');
            if (wasColored && !detectTimer) {
                // delay matches the bg transition so text flips after bg fades
                detectTimer = setTimeout(function () {
                    detectTimer = null;
                    detectTheme();
                }, 350);
            } else if (!wasColored) {
                detectTheme();
            }
        }
    }

    navbar.classList.add('navbar-on-light');

    function redetect() {
        if (!navbar.classList.contains('navbar-color')) {
            detectTheme();
        }
    }

    function init() {
        var adminBar = document.querySelector('.navbar-admin');
        scrollThreshold = navbar.offsetHeight + (adminBar ? adminBar.offsetHeight : 0) || 80;
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();

        // Re-detect after first paint and after all resources load — fixes race
        // where elementFromPoint samples wrong element before layout settles
        requestAnimationFrame(redetect);
        window.addEventListener('load', redetect, { once: true });

    }

    // bfcache restore: browser may freeze page with navbars open; force-close all on restore
    window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        document.querySelectorAll('.navbar-collapse.in').forEach(function (collapse) {
            collapse.classList.remove('in');
            collapse.style.height = '';
        });
        document.querySelectorAll('.navbar-toggle').forEach(function (toggle) {
            toggle.classList.add('collapsed');
            toggle.setAttribute('aria-expanded', 'false');
        });
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();

// ── Mobile: row opens dropdown, parent link injected at top ──────────────────
(function ($) {
    'use strict';

    var BREAKPOINT = 992;

    function isMobile() {
        return window.innerWidth < BREAKPOINT;
    }

    $(function () {
        var $navbar = $('#navbar-main');
        if (!$navbar.length) return;

        // Inject parent page link as first item in each dropdown (mobile-only, once)
        $navbar.find('.navbar-nav .btn-group').each(function () {
            var $group    = $(this);
            var $link     = $group.children('a').first();
            var href      = $link.attr('href');
            var label     = $link.find('span[itemprop="name"]').text().trim() || $link.text().trim();
            var $dropdown = $group.children('.dropdown-menu');

            if (!href || !$dropdown.length) return;

            $dropdown.prepend(
                '<li class="mobile-parent-link"><a href="' + href + '"><span>' + label + '</span></a></li>' +
                '<li class="divider mobile-parent-divider"></li>'
            );
        });

        // Tap on parent link text on mobile → open dropdown instead of navigating
        $navbar.find('.navbar-nav .btn-group > a').on('click.mobileNav', function (e) {
            if (!isMobile()) return;
            e.preventDefault();
            e.stopPropagation();
            var $group = $(this).closest('.btn-group');
            var isOpen = $group.hasClass('open');
            // close all open dropdowns first (Bootstrap behaviour)
            $navbar.find('.btn-group.open').removeClass('open');
            if (!isOpen) {
                $group.addClass('open');
            }
        });
    });

}(jQuery));

// ── Headroom ─────────────────────────────────────────────────────────────────
+function ($) {
    'use strict';
    var wiNavbars = window.wiNavbars;
    var navbar = $('#navbar-main');
    window.wiNavbars = {
        init: function () {
            var siteNav = document.querySelector('#navbar-main');
            var headroom = new Headroom(siteNav, {
                "offset": 225,
                "tolerance": 5,
                "classes": {
                    "initial": "animated",
                    "pinned": "slideInDown",
                    "unpinned": "slideOutUp"
                }
            });
            headroom.init();
        },
        refresh: function () {
        }
    };
    $(function () {
        wiNavbars = window.wiNavbars;
        wiNavbars.init();
    });
}(jQuery);
